<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div :class="['form-group', {'is-invalid': $v.loginData.user.$error}]">
      <input
        :class="{ 'is-invalid': $v.loginData.user.$error }"
        v-model.trim="loginData.user"
        class="form-control"
        placeholder="Ingrese usuario"
        type="text"
        @input="$v.loginData.user.$touch()"
      >
      <span v-if="!$v.loginData.user.required" class="invalid-feedback">
        El usuario es requerido
      </span>
    </div>
    <div :class="['form-group', {'is-invalid': $v.loginData.password.$error}]">
      <input
        :class="{ 'is-invalid': $v.loginData.password.$error }"
        v-model.trim="loginData.password"
        class="form-control"
        placeholder="Ingrese contraseña"
        type="password"
        @input="$v.loginData.password.$touch()"
      >
      <span v-if="!$v.loginData.password.required" class="invalid-feedback">
        La contraseña es requerida
      </span>
      <span v-if="!$v.loginData.password.minLength" class="invalid-feedback">
        La contraseña debe tener al menos {{ $v.loginData.password.$params.minLength.min }} letras.
      </span>
    </div>
    <!-- <div class="other-actions row">
      <div class="col-sm-6 text-sm-right">
        <a href="#" class="forgot-link">
          ¿Olvidó la contraseña?
        </a>
      </div>
    </div> -->
    <button
      slot="button"
      type="button"
      class="btn btn-primary ladda-button btn-full"
      data-style="expand-right"
      @click="validateBeforeSubmit"
    >Ingresar</button>
  </form>
</template>

<script type="text/babel">
import {required, minLength} from 'vuelidate/lib/validators'
import Auth from '../../services/auth'
import Roles from '../../services/roles'
import ladda from 'ladda'

export default {
  data () {
    return {
      loginData: {
        user: '',
        password: ''
      }
    }
  },
  validations: {
    loginData: {
      password: {
        required,
        minLength: minLength(6)
      },
      user: {
        required
      }
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$v.$touch()

      if (!this.$v.$error) {
        Roles.login(this.loginData).then((res) => {
          if(res) {
            console.log('revisa localstorage')
          }
        })

        Auth.login(this.loginData).then((res) => {
          if (res) {
            this.$router.push('/admin/menu')
          }
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/auth/Login.vue